import { useState } from "react";
import styled from "styled-components";
import { placelists } from "../resources/placelists";
import TextGothic from "./utils/TextGothic";
import MenuIcon from "./../components/MenuIcon";
import { colorCode } from "../resources/colors";
import { media } from "./../utils/media";

const Menu = () => {
  const [isMenuHoverd, setIsMenuHoverd] = useState<boolean>(false);
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const onMenuClick = () => {
    const body = document.getElementsByTagName("body")[0];
    if (isMenuOpen) {
      body.style.height = "";
      body.style.overflow = "";
      setIsMenuOpen(!isMenuOpen);
    } else {
      body.style.height = "100%";
      body.style.overflow = "hidden";
      setIsMenuOpen(!isMenuOpen);
    }
  };

  return (
    <>
      <Humberger
        onMouseEnter={() => setIsMenuHoverd(true)}
        onMouseLeave={() => setIsMenuHoverd(false)}
        onClick={onMenuClick}
      >
        <MenuIcon isHovered={isMenuHoverd} isClicked={isMenuOpen} />
      </Humberger>
      {isMenuOpen && (
        <Wrapper>
          <Content>
            <TextGothic size="20px">
              <PageLink href="/ja/jp/domtour/theme/workation/music">
                TOPページ
              </PageLink>
            </TextGothic>
            <List>
              {placelists.map((placelist, i) => (
                <Row key={`menu_placelist_${i}`}>
                  <TextGothic size="12px" lh={2}>
                    {"0" + (i + 1)}
                  </TextGothic>
                  <Box>
                    <TextGothic size="20px">
                      <PageLink
                        href={`/ja/jp/domtour/theme/workation/music/${placelist.id}`}
                      >
                        {placelist.title}
                      </PageLink>
                    </TextGothic>
                    {placelist.artists.map((artist, j) => (
                      <div key={`menu_artist_${j}`}>{artist}</div>
                    ))}
                  </Box>
                </Row>
              ))}
            </List>
          </Content>
        </Wrapper>
      )}
    </>
  );
};

const Wrapper = styled.div`
  width: 100vw;
  position: fixed;
  background-color: ${colorCode.baseGreen};
  z-index: 1;

  ${media.sp`
    height: calc(100vh - 75px);
    top: 75px;
  `}
  ${media.pc`
    height: calc(100vh - 92px);
    top: 92px;
  `}
`;

const Humberger = styled.div`
  position: fixed;
  width: 48px;
  height: 48px;
  z-index: 2;
  cursor: pointer;

  ${media.pc`
    right: calc(50vw - 480px);
    top: 156px;
  `}
  @media (max-width: 1020px) {
    right: 30px;
  }
  ${media.sp`
    right: 20px;
    top: 107px;
  `}
`;

const Content = styled.div`
  ${media.sp`
    padding: 96px 32px;
  `}
  ${media.pc`
    position: absolute;
    top: calc(50% - 46px);
    left: 50%;
    transform: translate(-50%, -50%);
  `}
`;

const Row = styled.div`
  display: flex;
  &:not(:last-child) {
    padding-bottom: 32px;
  }
`;

const List = styled.div`
  padding-top: 48px;
`;

const Box = styled.div`
  padding-left: 16px;
`;

const PageLink = styled.a`
  /* color: black; */
  /* text-decoration: none; */
  &:hover {
    text-decoration: underline;
  }
`;

export default Menu;
